<template>
    <div class="card relative min-h-[400px]
    w-auto h-auto
    bg-[#edf7ed]
    overflow-hidden
    text-center
    rounded-4xl
    border-2 border-[#b0cfc2]"
    :class="[props.customClass, { 'alternate-card': props.alternate, 'card-compact': props.compact }]"
    :style="cardStyle"
    >
        <h1 class="title text-4xl font-bold mb-5 line-height-[1.2px] text-[#4a6350]">
            {{ newTitleWords }} 
            <span :class="{ 'last-word': highlightLastWord }">{{ lastWord }}</span>
        </h1>
        <div class="text-content mb-4 line-height-[1.6px] text-lg text-[#4a6350]">
            <slot name="text"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

interface Props {
    title: string;
    highlightLastWord: boolean;
    alternate?: boolean;
    customClass?: string | string[];
    compact?: boolean;
}
const props = defineProps<Props>();

const titleWords = ref<string[]>(props.title.split(' '));
const lastWord = titleWords.value.pop();
const newTitleWords = ref<string>(titleWords.value.join(' ')) 

const cardStyle = computed(() => {
    if (props.compact) {
        return {
            display: 'inline-block',
            width: 'fit-content',
            maxWidth: 'none',
            minWidth: '0',
            padding: 'clamp(0.75rem, 1vw, 1rem)',
        };
    }

    return {
        width: 'min(1200px, calc(100vw - 2rem))',
        maxWidth: '1200px',
        margin: '2.5rem auto',
        padding: 'clamp(0.75rem, 1vw, 1rem)',
    };
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500&display=swap');

.card {
    font-family: 'Montserrat', sans-serif;
    text-shadow: 0px 0px 3px #a8c3b4; 
    box-shadow: 0px 0px 10px 2px rgba(144, 183, 167, 0.6); 
    transition: width 220ms ease, max-width 220ms ease, padding 220ms ease, margin 220ms ease, flex-basis 220ms ease;
}

.card-compact {
    min-height: 0;
    align-self: flex-start;
}

.title {
    font-family: 'Montserrat', sans-serif;
}

.last-word {
    color: #6a998f; 
    text-shadow: 
        2px 3px 3px rgba(0, 0, 0, 0.3), 
        1px 0px 3px #90b7a7; 
}

.text-content {
    font-family: 'Work Sans', sans-serif;
}
</style>
